@if (value() != undefined && value() != null) {
  <span [ngClass]="{
          'rounded-full py-1 font-medium': hasCustomColors(),
          'px-3': hasCustomColors() || columnHasDisplayStyle(),
          'truncate': !disableTruncate()
        }"
        class="text-sm text-widget sm:text-xs"
        [style.overflow-wrap]="disableTruncate() ? 'anywhere' : null"
        [style.text-wrap]="disableTruncate() ? 'pretty' : null"
        [style.background-color]="backgroundColor()"
        [style.color]="foregroundColor()">
    {{ value() }}
  </span>
}
